import { formatHtml } from "@trumpf/ux.common-storybook";
import { Template, TemplateMultipleItems } from "./location-block.templates";

export default {
    title: "Components/Location Block (G.6)",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    render: Template.bind({}),
    component: "ux-iws-location-block",
};

export const Default = {};

export const MultipleItems = {
    render: TemplateMultipleItems.bind({}),
};
